import { __exports as intlBrowser } from './_virtual-intl-browser.js';

var hasRequiredIntlBrowser;

function requireIntlBrowser () {
	if (hasRequiredIntlBrowser) return intlBrowser;
	hasRequiredIntlBrowser = 1;

	Object.defineProperty(intlBrowser, "__esModule", {
	  value: true
	});
	intlBrowser.default = getIntl;
	function getIntl() {
	  return Intl;
	}
	
	return intlBrowser;
}

export { requireIntlBrowser as __require };
//# sourceMappingURL=vp-js-token-engine-build-infrastructure-intl-browser.js.map
